import { toast } from "sonner";
import {
  READ_DATE_STORAGE_KEY,
  READ_LIST_STORAGE_KEY,
  userBackend,
} from "../../services";
import store from "../../state/store";
import { actions } from "../../state/reducer";

export const refreshInterval = 20000;
export const closeHotInterval = 5000;

export async function refreshNotifications() {
  return new Promise((resolve) => {
    const lastRead = localStorage.getItem(READ_DATE_STORAGE_KEY) || 0;
    userBackend
      .getNotifications()
      .then((res) => {
        const items = res.list;

        store.dispatch(actions.notificationList(items));
        // Какие уведомления уже всплывали
        const readList = localStorage.getItem(READ_LIST_STORAGE_KEY),
          parsedReadList: number[] = readList
            ? [...readList.split(",").map(Number)]
            : [];
        // Не показываем те, которые уже всплывали, даже если они не были прочитаны
        const mustUnread = items.filter((item) => {
          if (parsedReadList.includes(item.id)) return false;
          return new Date(item.date * 1000).getTime() > Number(lastRead);
        });
        const newHot =
          mustUnread.length > 0 ? mustUnread[mustUnread.length - 1] : null;
        const updatedReadList: number[] = newHot
          ? parsedReadList.concat([newHot.id])
          : parsedReadList;
        localStorage.setItem(READ_LIST_STORAGE_KEY, String(updatedReadList));
        store.dispatch(actions.hotNotify(newHot));
        setTimeout(() => {
          store.dispatch(actions.hotNotify(null));
        }, closeHotInterval);
        resolve(1);
      })
      .catch((e) => {
        console.log(e);
        toast("Не удалось загрузить уведомления");
      });
  });
}
